import { useCallback } from 'react'
import { SectionTitle } from '../ProjectsCreate/ProjectsCreate'
import ProjectOdsOdpTable from './ProjectOdsOdpTable'
import { viewModesHandler } from './ViewHelperComponents'
import { textAreaViewClassname, viewColumnsClassName } from '../constants'
import { ProjectViewProps } from '../interfaces'
import {
  canViewField,
  getFieldData,
  filterEmptyOdsOdpRows,
  getOdsOdpFields,
  getSectionFields,
  hasFields,
} from '../utils'
import { useStore } from '@ors/store'

import { Divider } from '@mui/material'
import { groupBy, map } from 'lodash'

const ProjectSpecificInfo = ({
  project,
  specificFields,
  fieldHistory,
}: { fieldHistory?: any } & ProjectViewProps) => {
  const headerFields = getSectionFields(specificFields, 'Header')
  const substanceFields = getSectionFields(specificFields, 'Substance Details')

  const field = 'ods_odp'

  const groupedFields = groupBy(substanceFields, 'table')
  const projectFields = groupedFields['project'] || []
  const odsOdpFields = getOdsOdpFields(substanceFields)
  const odpDisplayField = getFieldData(odsOdpFields, 'ods_display_name')

  const { projectFields: allFields, viewableFields } = useStore(
    (state) => state.projectFields,
  )

  const canViewOverviewSection =
    headerFields.length > 0 && hasFields(allFields, viewableFields, 'Header')
  const canViewSubstanceDetailsSection =
    substanceFields.length > 0 &&
    hasFields(allFields, viewableFields, 'Substance Details')
  const canViewSubstanceSection = hasFields(
    allFields,
    viewableFields,
    'ods_odp',
    true,
    [],
    'table',
  )

  const data =
    filterEmptyOdsOdpRows([...(project?.[field] || [])]).sort(
      (field1, field2) => (field1.sort_order ?? 0) - (field2.sort_order ?? 0),
    ) || []

  const getFieldHistory = useCallback(
    (name: string) => {
      return fieldHistory?.[name] ?? []
    },
    [fieldHistory],
  )

  return (
    <>
      {canViewOverviewSection && (
        <>
          <SectionTitle>Overview</SectionTitle>
          <div className="flex w-full flex-col gap-4">
            <div className={viewColumnsClassName}>
              {map(
                headerFields,
                (field) =>
                  canViewField(viewableFields, field.write_field_name) && (
                    <span key={field.write_field_name}>
                      {viewModesHandler[field.data_type](
                        project,
                        field,
                        undefined,
                        getFieldHistory(field.write_field_name),
                      )}
                    </span>
                  ),
              )}
            </div>
          </div>
        </>
      )}

      {canViewOverviewSection && canViewSubstanceDetailsSection && (
        <Divider className="my-6" />
      )}

      {canViewSubstanceDetailsSection && (
        <>
          <SectionTitle>
            {odpDisplayField || odsOdpFields.length === 0
              ? 'Substance'
              : 'Phase out'}{' '}
            details
          </SectionTitle>
          <div className="flex w-full flex-col gap-4">
            <div
              className={projectFields.length > 1 ? viewColumnsClassName : ''}
            >
              {map(projectFields, (field) => (
                <span key={field.write_field_name}>
                  {canViewField(viewableFields, field.write_field_name) &&
                    viewModesHandler[field.data_type](
                      project,
                      field,
                      field.write_field_name === 'products_manufactured'
                        ? textAreaViewClassname
                        : undefined,
                      getFieldHistory(field.write_field_name),
                    )}
                </span>
              ))}
            </div>
            {canViewSubstanceSection && odsOdpFields.length > 0 && (
              <ProjectOdsOdpTable
                data={data}
                fields={odsOdpFields}
                history={getFieldHistory('ods_odp')}
              />
            )}
          </div>
        </>
      )}
    </>
  )
}

export default ProjectSpecificInfo
